import { ApiPermissions, ConnectionStatus } from "../cefi";
import { PortfolioToken } from "../portfolio";

export interface AccountSettings {
  hiddenTokens: PortfolioToken[]; // TODO: We don't need to save as much data here
}

export type AccountId = string;

/**
 * @description Public account data, that can be exposed to the UI and to the dApp.
 *
 * It's important to keep parentVault property out of this type, because it's a circular dependency,
 * and most importantly, it exposes the private vault data.
 */
export type PublicAccount = {
  id: AccountId;
  status: ConnectionStatus;
  accountName: string;
  exchangeId: string;
  permissions: ApiPermissions[];
  settings?: AccountSettings;
  isOauth?: boolean;
  isFastApi?: boolean;
  isReadOnly?: boolean;
  exchangeUserId?: string;
};
